import { WebLayout } from 'components/Layout';
import React from 'react';
import { Head } from 'components/Head';
import { Banner } from '../components/Banner';
import { LatestNews } from '../components/LatestNews';
import { PowerResearch } from '../components/PowerResearch';
import { MoreReports } from '../components/MoreReports';
import { FeaturedToolkit } from '../components/FeaturedToolkit';
import { OurImpact } from '../components/OurImpact';
import { WhatCanYouDo } from '../components/WhatCanYouDo';
import OurPartners from '../components/OurPartners';
import { SeedsOfSuccess } from '../components/SeedsOfSuccess';
import { AccelerateGrowth } from '../components/AccelerateGrowth';
import { RootsThatLast } from '../components/RootsThatLast';

export const Landing = () => {
  return (
    <WebLayout>
      <Head
        title="Home"
        description="Providing entreprenuership training and support for women in green sectors."
      />
      <div className="">
        <>
          <div className="md:mx-48 mt-24">
            <Banner />
          </div>
        </>
        <>
          <div className="flex flex-col md:flex-row md:justify-center md:items-center mx-8 md:mx-48 my-8 md:my-24 gap-4">
            <div className="bg-[#d3e4e2] p-8 w-[100%] md:w-[30%] text-center md:text-left rounded-lg">
              ISPUGANDA IS A GLOBAL COMMUNITY BLENDING INTENSIVE TRAINING WITH FAITH-BASED
              PRINCIPLES AND ACCESS TO CAPITAL
            </div>
            <div className="p-8 w-[100%] md:w-[30%] text-center md:text-left rounded-lg">
              Entrepreneurs learn how to scale their businesses while also making a social &
              spiritual impact in their community.
            </div>
          </div>
        </>
        <>
          <div className="bg-green-600 p-12 text-center">
            <div className="text-4xl font-bold">IT'S A GLOBAL COMMUNITY</div>
            <div className="text-white my-12">ENTREPRENEURS, MENTORS & INVESTORS</div>
            <div className="text-xl md:w-1/4 mx-auto">
              Our network of relationships offers world-class training & coaching, accountability &
              discipleship, and access to capital for your professional journey.
            </div>
          </div>
        </>
        <>
          <div className="md:mx-48">
            <SeedsOfSuccess />
          </div>
        </>
        <>
          <div className="md:mx-48">
            <AccelerateGrowth />
          </div>
        </>
        <>
          <div className="md:mx-48">
            <RootsThatLast />
          </div>
        </>
      </div>
    </WebLayout>
  );
};
